<template>
	<div class="retrun" @click="retrun">
		返回首页
	</div>
</template>

<script>
	export default {
		methods: {

			retrun: function() {
				this.$router.push({
					path: '/'
				})
			},
		},
	}
</script>

<style>
	.retrun {
		margin: 20px 0;
		cursor: pointer;
		color: rgb(20, 90, 245);
		font-size: 1.125rem;
		font-weight: bold;
		display: inline-block;
	}

	.retrun:hover {
		color: #49a8eb;
	}
	@media (max-width:31.25rem) {
		.retrun {
			display: none;
		}
	}

</style>
